import { HotToastModule } from "@ngneat/hot-toast";
import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, LOCALE_ID, NgModule } from "@angular/core";
import localeEs from "@angular/common/locales/es";
import { registerLocaleData } from "@angular/common";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import "./routes";

// azure
import {
	MsalBroadcastService,
	MsalModule,
	MsalService,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
} from "@azure/msal-angular";
import {
	MSALInstanceFactory,
	MSALInterceptorConfigFactory,
} from "./azure-ad";
import { OverlayModule } from "@angular/cdk/overlay";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import {
	AzureAuthInterceptor,
	AzureSsoService,
} from "./core/auth";

registerLocaleData(localeEs, "es");

export function initializeAzureSso(
	azureSsoService: AzureSsoService
): () => Promise<void> {
	return () => azureSsoService.initialize();
}

const providersAzure = [
	{
		provide: HTTP_INTERCEPTORS,
		useClass: AzureAuthInterceptor,
		multi: true,
	},
	{
		provide: MSAL_INSTANCE,
		useFactory: MSALInstanceFactory,
	},
	{
		provide: MSAL_INTERCEPTOR_CONFIG,
		useFactory: MSALInterceptorConfigFactory,
	},
	MsalService,
	MsalBroadcastService,
	{
		provide: APP_INITIALIZER,
		useFactory: initializeAzureSso,
		deps: [AzureSsoService],
		multi: true,
	},
];

// providers 'es-ES'

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserAnimationsModule,
		HttpClientModule,
		BrowserModule,
		AppRoutingModule,
		MsalModule,
		HotToastModule.forRoot({
			loading: {
				duration: 999999,
			},
			dismissible: true,
		}),
		OverlayModule,
		MatDialogModule,
		MatSnackBarModule
	],
	providers: [
		...providersAzure,
		{ provide: LOCALE_ID, useValue: "es-Es" },
		// MustBeAuthenticate,
		// MustBeUnregister,
	], // LoginGuard, MustBeAuthenticate
	bootstrap: [AppComponent],
})
export class AppModule {}
